import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import ButtonBase from '@material-ui/core/ButtonBase'
import messages from '../../messages'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

export const useStyles = makeStyles((theme: Theme) => {
  return {
    textWrapper: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 900,
    },
    text: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    icon: {
      position: 'relative',
      top: 1,
      color: theme.palette.primary.main,
      fontWeight: 900,
      marginLeft: theme.spacing(1),
    },
  }
})

enum Products {
  SiRNA = 'sirna',
}

interface PricingIconProps {
  onClick: (e: React.MouseEvent) => void
  detailsExpanded: boolean
  productType?: any
}

const PricingIcon: React.FC<PricingIconProps> = ({
  onClick,
  detailsExpanded,
  productType,
}) => {
  const classes = useStyles()
  const priceIcon = detailsExpanded ? (
    <ExpandLessIcon className={classes.icon} />
  ) : (
    <ExpandMoreIcon className={classes.icon} />
  )
  const expandLink = detailsExpanded ? (
    <>
      <FormattedMessage {...messages.HIDE} />
      <ExpandLessIcon className={classes.icon} />
    </>
  ) : (
    <>
      <FormattedMessage {...messages.EXPAND} />
      <ExpandMoreIcon className={classes.icon} />
    </>
  )
  return (
    <ButtonBase
      aria-expanded={detailsExpanded}
      aria-label="Show Pricing"
      onClick={onClick}
    >
      {productType === Products.SiRNA ? (
        <>
          <span className={classes.textWrapper}>
            <span className={classes.text}></span>
            {expandLink}
          </span>
        </>
      ) : (
        <>
          <FormattedMessage {...messages.SEMI_CONF_DETAILS_crispgrna}>
            {(message) => (
              <span className={classes.textWrapper}>
                <span className={classes.text}>{message}</span>
                {priceIcon}
              </span>
            )}
          </FormattedMessage>
        </>
      )}
    </ButtonBase>
  )
}

export default PricingIcon
